






































import { Component, Vue, Prop } from 'vue-property-decorator'
import AirportService from '@/services/AirportService'
import IAirport from '@/store/interface/IAirport'
import { required } from 'vuelidate/lib/validators'
import { TranslateResult } from 'vue-i18n'

@Component({
	name: 'AirportAutosuggest',
	validations: {
		modelData: {
			iata: { required }
		}
	}
})
export default class AirportAutosuggest extends Vue {
	@Prop()
	private airportData!: IAirport
	@Prop({ default: 0 })
	private currentIndex!: number
	@Prop({ default: false })
	private isDisabled!: false
	@Prop({ default: false })
	private isDeparture!: boolean
	private modelData: IAirport = { ...this.airportData }
	private suggestedAirports: IAirport[] = []
	private options: IAirport[] = this.suggestedAirports

	private onInput (value: IAirport): void {
		const ref: string = this.isDeparture ? 'depAirport' : 'arrAirport'
		this.$emit('field-updated', value, ref, this.currentIndex)
	}

	private getAutoSuggestedAirportList (query: string, update: any): void {
		const locale: string = this.$i18n.locale
		const currentCountry: string = locale && locale.length === 5 ? locale.substring(3, 5).toLowerCase() : 'us'

		AirportService.getAirportByQuery(query, currentCountry)
			.then((data: any) => {
				const dataIsNotEmpty: boolean = !!data.length
				this.suggestedAirports = dataIsNotEmpty ? data : []
				this.options = this.suggestedAirports

				// update is the callback function of QSelect, that updates the dropdown
				update()
			})
			.catch((e: Error) => {
				console.error(e)
			})
	}

	/**
	 * Returns the options label in the format of "airport name (airportIata)"
	 * example: Frankfurt (FRA)
	 * @param item
	 */
	private getOptionLabel (item: IAirport): string {
		return item && item.iata ? `${item.name} (${item.iata})` : ''
	}

	/**
	 * Returns the option value in the format IAirport object"
	 * @param item
	 */
	private getOptionValue (item: IAirport): IAirport | null {
		return item && item.iata ? item : null
	}
}
